<template>
  <div class="message-details details">
    <div class="close" v-on:click="close()"><b-icon icon="close" size="is-large" /></div>
    <h3 class="message-key">{{key|toLabel}}</h3>
    <b-field label="Subject">
      <b-input type="text" class="subject-field" maxlength="128" v-model="subject" placeholder="Subject"></b-input>
    </b-field>
    <b-field label="Body">
      <vue-editor id="text-editor" :editorToolbar="customToolbar" v-model="body"> </vue-editor>
    </b-field>
    <b-field label="From name">
      <b-input type="text" class="from-name-field" maxlength="128" v-model="fromName" placeholder="From name"></b-input>
    </b-field>
    <b-field label="From email">
      <b-input type="text" class="from-mail-field" maxlength="128" v-model="fromMail" placeholder="From email"></b-input>
    </b-field>
    <h4>Available tokens</h4>
    <dl class="dict-grid">
      <dt>%full_name</dt>
      <dd>Recipients first and last names (as entered during registration)</dd>
      <dt>%email</dt>
      <dd>Recipient's email address.</dd>
      <dt>%reset_link</dt>
      <dd>Temporary password reset link</dd>
      <dt>%access_link</dt>
      <dd>Link to application login. Will reload the application form is session is still active or prompt for login wtth email and password.</dd>
    </dl>
    <b-button type="is-success" @click="save" class="save" rounded>Save</b-button>
    <p v-if="saveMessage.length > 2" class="message">{{saveMessage}}</p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import filters from "../mixins/filters";
import { saveMessage } from "../api/methods";
import { messageSchema } from "../store/schemas";
import { bus } from "../main";

export default {
  name: 'MessageDetail',
  components: {
    VueEditor
  },
  props: {
     message: {
       type: Object,
       default() {
         return messageSchema;
       }
     }
  },
  mixins: [filters],
  mounted() {
    if (this.message instanceof Object) {
      if (this.message.subject) {
        this.subject = this.message.subject;
      }
      if (this.message.body) {
        this.body = this.message.body;
      }
      if (this.message.fromName) {
        this.fromName = this.message.fromName;
      }
      if (this.message.fromMail) {
        this.fromMail = this.message.fromMail;
      }
    }
  },
  created() {
    
  },
  data() {
    return {
      subject: '',
      body: '',
      fromName: '',
      fromMail: '',
      saveMessage: ''
    }
  },
  computed: {
    ...mapGetters(["settings", "customToolbar"]),
    key() {
      return this.message.key;
    }
  },
  methods: {
    close() {
      this.$parent.close();
    },
    save() {
      const { _id } = this.message;
      saveMessage(_id, {
        subject: this.subject,
        body: this.body,
        fromName: this.fromName,
        fromMail: this.fromMail,
      }).then(data => {
        if (data.valid) {
          this.saveMessage = "Message successfully saved";
            bus.$emit('message-updated', data);
          }
          setTimeout(() => {
            this.$parent.close();
          }, 1000);
          setTimeout(() => {
            this.saveMessage = '';
          }, 1500);
      })
    },
  },
}
</script>